import moment, { Moment } from 'moment';

/**
 * 生成日期范围数组
 * @param startDate - 开始日期，支持字符串或Moment对象
 * @param endDate - 结束日期，支持字符串或Moment对象
 * @param [intervalType='day'] - 间隔类型，可选值：'hour' | 'day' | 'month'
 * @returns 返回格式化后的日期字符串数组
 */
const generateDateRanges = (
  startDate: string | Moment,
  endDate: string | Moment,
  intervalType?: 'hour' | 'day' | 'month',
) => {
  const start = moment(startDate);
  const end = moment(endDate);
  const result: string[] = [];

  if (!start.isValid() || !end.isValid() || start.isAfter(end)) {
    console.log("★ ~ 开始时间或结束时间无效:", start, end);
    return result;
  }

  switch ((intervalType || 'day').toLowerCase()) {
    case 'hour':
      while (start.isBefore(end)) {
        result.push(start.format('YYYY-MM-DD HH:mm:ss'));
        start.add(1, 'hour');
      }
      break;
    case 'day':
      while (start.isBefore(end)) {
        result.push(start.format('YYYY-MM-DD'));
        start.add(1, 'day');
      }
      break;
    case 'month':
      while (start.isBefore(end)) {
        result.push(start.format('YYYY-MM'));
        start.add(1, 'month');
      }
      break;
    default:
      console.log("★ ~ 无效的间隔类型intervalType:", intervalType);
  }

  return result;
};

export default generateDateRanges;
